import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";
import Select from "react-select";
import { toast } from "react-toastify";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "6px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#f8fafc",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#ffc107",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};
export default function ReactTables() {
  

  const { accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [dataRows, setdataRows] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [toggle, setToggle] = React.useState();
  const [toggleLocation, setToggleLocation] = React.useState();
  // const [toggleTestPlayStore, setToggleTestPlayStore] = React.useState();
  // const [toggleTestAppStore, setToggleTestAppStore] = React.useState();
  const [toggleKycCheck, setToggleKycCheck] = React.useState();
  const [toggleAddMoneyCheck, setToggleAddMoneyCheck] = React.useState();
  const [toggleSendEmail, setToggleSendEmail] = React.useState();
  const [buttonLoader, setButtonLoader] = React.useState(false);

  React.useEffect(() => {
    setLoader(true);
    axios(`${API_URL}/api/admin/setting/get-setting`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        if (response.data.status) {
          console.log(" gameSettings:::", response.data.data);
          setdataRows(response.data.data);
        } else {
          toast.error(response.data.message || "Failed to fetch settings");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("getBranch error :::", error);
        toast.error("Network error: Failed to fetch settings");
      });
  }, []);

  const LoginSchema = Yup.object().shape({
    maintenanceText: Yup.string().required("required"),
    welcomeMailText: Yup.string().required("required"),
    apiKey: Yup.string().required("required"),
    currencyStatus: Yup.string().required("required"),
    currencyMultiply: Yup.string().required("required"),
  });

  return (
    <>
      {dataRows && (
        <div class=" p-3 ">
          <div className="card p-3 border-0 shadow-sm">
            <Formik
              initialValues={{
                maintenanceText: dataRows?.maintenanceText,
                welcomeMailText: dataRows?.welcomeMailText,
                apiKey: dataRows?.apiKey,
                currencyStatus: dataRows?.currencyStatus,
                currencyMultiply: dataRows?.currencyMultiply,
              }}
              validationSchema={LoginSchema}
              onSubmit={(values) => {
                setButtonLoader(true);
                let valueOnOff = dataRows?.maintenance;
                let valueOnOffLocation = dataRows?.location;
                // let valueOnOffTestPlayStore = dataRows?.testPlayStore;
                // let valueOnOffTestAppStore = dataRows?.testAppStore;
                let valueOnOffKycCheck = dataRows?.kycCheck;
                let valueOnOffAddMoneyCheck = dataRows?.addMoneyCheck;
                let valueOnOffSendEmail = dataRows?.sendWelcomeMail;

                if (toggle == true) {
                  valueOnOff = true;
                }
                if (toggle == false) {
                  valueOnOff = false;
                }

                if (toggleLocation == true) {
                  valueOnOffLocation = true;
                }
                if (toggleLocation == false) {
                  valueOnOffLocation = false;
                }

                // if (toggleTestPlayStore == true) {
                //   valueOnOffTestPlayStore = true;
                // }
                // if (toggleTestPlayStore == false) {
                //   valueOnOffTestPlayStore = false;
                // }

                // if (toggleTestAppStore == true) {
                //   valueOnOffTestAppStore = true;
                // }
                // if (toggleTestAppStore == false) {
                //   valueOnOffTestAppStore = false;
                // }

                // toggleKycCheck
                if (toggleKycCheck == true) {
                  valueOnOffKycCheck = true;
                }
                if (toggleKycCheck == false) {
                  valueOnOffKycCheck = false;
                }

                // toggleAddMoneyCheck
                if (toggleAddMoneyCheck == true) {
                  valueOnOffAddMoneyCheck = true;
                }
                if (toggleAddMoneyCheck == false) {
                  valueOnOffAddMoneyCheck = false;
                }

                // toggleSendEmail
                if (toggleSendEmail == true) {
                  valueOnOffSendEmail = true;
                }
                if (toggleSendEmail == false) {
                  valueOnOffSendEmail = false;
                }

                const onOffToggle = {
                  maintenance: valueOnOff,
                  location: valueOnOffLocation,
                  // testPlayStore: valueOnOffTestPlayStore,
                  // testAppStore: valueOnOffTestAppStore,
                  kycCheck: valueOnOffKycCheck,
                  addMoneyCheck: valueOnOffAddMoneyCheck,
                  sendWelcomeMail: valueOnOffSendEmail,
                };
                let merged = {
                  ...values,
                  ...onOffToggle,
                  id: dataRows?._id,
                };
                console.log("merged", merged);

                axios(
                  `${API_URL}/api/admin/setting/update-setting/${dataRows?._id}`,
                  {
                    method: "PATCH",
                    credentials: "include",
                    data: merged,
                  }
                )
                  .then((result) => {
                    console.log("handleSubmit result :::", result.data);
                    alert(result.data.message);
                    socket.emit("maintenanceUpdate");
                    setButtonLoader(false);
                  })
                  .catch((err) => {
                    console.log("handleSubmit err :::", err);
                  });
              }}
            >
              {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                <div style={{ width: "100%" }}>
                  {accessObject?.getSetting == true ? (
                    <>
                      <Form>
                        {/* Form Inputs */}
                        <div className="row mb-2">
                          <div className="col-md-12 mb-4">
                            <label className="font-weight-bold text-muted small mb-2">
                              Api Key
                            </label>
                            <Field
                              type="text"
                              name="apiKey"
                              disabled={!accessObject?.editSetting}
                              placeholder="Enter Api Key"
                              className={`form-control ${
                                touched.apiKey && errors.apiKey ? "is-invalid" : ""
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 15px",
                                border: "1px solid #e2e8f0",
                                backgroundColor: "#f8fafc",
                                height: "auto"
                              }}
                            />
                            <ErrorMessage component="div" name="apiKey" className="invalid-feedback" />
                          </div>

                          <div className="col-md-12 mb-4">
                            <label className="font-weight-bold text-muted small mb-2">
                              Maintenance Text
                            </label>
                            <Field
                              type="text"
                              name="maintenanceText"
                              disabled={!accessObject?.editSetting}
                              placeholder="Enter Maintenance Text"
                              className={`form-control ${
                                touched.maintenanceText && errors.maintenanceText ? "is-invalid" : ""
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 15px",
                                border: "1px solid #e2e8f0",
                                backgroundColor: "#f8fafc",
                                height: "auto"
                              }}
                            />
                            <ErrorMessage component="div" name="maintenanceText" className="invalid-feedback" />
                          </div>

                          <div className="col-md-6 mb-4">
                            <label className="font-weight-bold text-muted small mb-2">
                              Currency Status
                            </label>
                            <Select
                              styles={filterSelectStyles}
                              isDisabled={!accessObject?.editSetting}
                              options={[
                                { value: 1, label: "Dollar" },
                                { value: 0, label: "Coin" }
                              ]}
                              value={
                                [{ value: 1, label: "Dollar" }, { value: 0, label: "Coin" }].find(
                                  (option) => option.value == values.currencyStatus
                                )
                              }
                              onChange={(option) => setFieldValue("currencyStatus", option.value)}
                              menuPortalTarget={document.body}
                              className={touched.currencyStatus && errors.currencyStatus ? "is-invalid" : ""}
                            />
                            <ErrorMessage component="div" name="currencyStatus" className="invalid-feedback" />
                          </div>

                          <div className="col-md-6 mb-4">
                            <label className="font-weight-bold text-muted small mb-2">
                              Currency Multiply
                            </label>
                            <Field
                              type="number"
                              name="currencyMultiply"
                              placeholder="Enter Currency Multiply"
                              autoComplete="off"
                              disabled={!accessObject?.editSetting}
                              className={`form-control ${
                                touched.currencyMultiply && errors.currencyMultiply ? "is-invalid" : ""
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 15px",
                                border: "1px solid #e2e8f0",
                                backgroundColor: "#f8fafc",
                                height: "auto"
                              }}
                            />
                            <ErrorMessage component="div" name="currencyMultiply" className="invalid-feedback" />
                          </div>

                          <div className="col-md-12 mb-4">
                            <label className="font-weight-bold text-muted small mb-2">
                              Welcome Mail Text
                            </label>
                            <Field
                              as="textarea"
                              rows={5}
                              name="welcomeMailText"
                              disabled={!accessObject?.editSetting}
                              placeholder="Enter Welcome Mail Text"
                              className={`form-control ${
                                touched.welcomeMailText && errors.welcomeMailText ? "is-invalid" : ""
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 15px",
                                border: "1px solid #e2e8f0",
                                backgroundColor: "#f8fafc"
                              }}
                            />
                            <ErrorMessage component="div" name="welcomeMailText" className="invalid-feedback" />
                          </div>
                        </div>

                        {/* Toggles Row */}
                        <div className="row mb-4">
                          <div className="col-auto mr-4 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold text-muted small mb-2 d-block">
                                Maintenance
                              </label>
                              <label className="switch mt-1">
                                <input
                                  type="checkbox"
                                  name="toggle"
                                  disabled={!accessObject?.editSetting}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    setToggle(e.target.checked);
                                  }}
                                  defaultChecked={dataRows?.maintenance === true}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>

                          <div className="col-auto mr-4 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold text-muted small mb-2 d-block">
                                Location
                              </label>
                              <label className="switch mt-1">
                                <input
                                  type="checkbox"
                                  name="toggleLocation"
                                  disabled={!accessObject?.editSetting}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    setToggleLocation(e.target.checked);
                                  }}
                                  defaultChecked={dataRows?.location === true}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>

                          <div className="col-auto mr-4 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold text-muted small mb-2 d-block">
                                KYC Check
                              </label>
                              <label className="switch mt-1">
                                <input
                                  type="checkbox"
                                  name="toggleKycCheck"
                                  disabled={!accessObject?.editSetting}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    setToggleKycCheck(e.target.checked);
                                  }}
                                  defaultChecked={dataRows?.kycCheck === true}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>

                          <div className="col-auto mr-4 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold text-muted small mb-2 d-block">
                                Add Money Check
                              </label>
                              <label className="switch mt-1">
                                <input
                                  type="checkbox"
                                  name="toggleAddMoneyCheck"
                                  disabled={!accessObject?.editSetting}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    setToggleAddMoneyCheck(e.target.checked);
                                  }}
                                  defaultChecked={dataRows?.addMoneyCheck === true}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>

                          <div className="col-auto mr-4 mb-3">
                            <div className="form-group">
                              <label className="font-weight-bold text-muted small mb-2 d-block">
                                Send Email
                              </label>
                              <label className="switch mt-1">
                                <input
                                  type="checkbox"
                                  name="toggleSendEmail"
                                  disabled={!accessObject?.editSetting}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    setToggleSendEmail(e.target.checked);
                                  }}
                                  defaultChecked={dataRows?.sendWelcomeMail === true}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        {accessObject?.editSetting && (
                          <div className="mt-2">
                            <button
                              type="submit"
                              className="btn btn-warning font-weight-bold px-4"
                              disabled={buttonLoader}
                              style={{
                                borderRadius: "8px",
                                border: "none",
                                height: "45px",
                                boxShadow: "0 4px 6px -1px rgba(255, 193, 7, 0.2)",
                                color: "#000"
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-center">
                                <span>Submit</span>
                                {buttonLoader && (
                                  <div className="spinner-border spinner-border-sm ml-2" role="status"></div>
                                )}
                              </div>
                            </button>
                          </div>
                        )}
                      </Form>
                    </>
                  ) : (
                    <>
                      <table
                        style={{
                          width: "100%",
                          backgroundColor: "rgba(0,0,0,.05)",
                        }}
                      >
                        <tr>
                          <td colSpan={7} className="p-3">
                            <h5 className="text-center mb-0">Access Denied</h5>
                          </td>
                        </tr>
                      </table>
                    </>
                  )}
                </div>
              )}
            </Formik>
          </div>
        </div>
      )}
      {accessObject?.getSetting == true && loader && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      )}
    </>
  );
}
